import { LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import type { SignoutNotice } from '../../../../common/services/device-session.service';

const EXPLAINED = ['replaced', 'revoked_by_vendor', 'revoked_by_admin', 'seat_taken', 'password_changed'];


/** Why this device was signed out, shown once on the login page. */
export function SignedOutNotice({ notice }: { notice: SignoutNotice }) {
  const { t } = useTranslation();
  // A plain sign-out needs no explanation.
  if (notice.reason === 'signed_out') return null;
  return (
    <Alert className="animate-form-item mb-6" data-testid="signed-out-notice">
      <LogOut />
      <AlertTitle>{t('SEATS.SIGNED_OUT.TITLE')}</AlertTitle>
      <AlertDescription>
        {t(`SEATS.SIGNED_OUT.${EXPLAINED.includes(notice.reason) ? notice.reason.toUpperCase() : 'MISSING'}`)}
      </AlertDescription>
    </Alert>
  );
}
